<mat-card class="height-100">
  <mat-card-header>
    <mat-card-title>Adicionar série fiscal</mat-card-title>
  </mat-card-header>
  <mat-card-content class="row">
    <div class="flex align-items-center justify-content-between width-100">
      <div class="col-md-4 mt-2">
        <span class="p-float-label">
          <p-dropdown
            [(ngModel)]="form.value.modelo"
            [formControl]="form.get('modelo')"
            [options]="tiposModelo"
            optionLabel="viewValue"
            styleClass="width-100"
            [disabled]="entity.modelo"
            id="float-input"
          >
          </p-dropdown>
          <label for="float-input">Modelo *</label>
        </span>
        <small
          class="p-error"
          *ngIf="
            form.get('modelo').dirty && form.get('modelo').hasError('required')
          "
        >
          {{ displayMessages.modelo.required }}
        </small>
      </div>
      <div class="col-md-8 mt-2">
        <span class="p-float-label">
          <p-dropdown
            [(ngModel)]="form.value.ambiente"
            [formControl]="form.get('ambiente')"
            [options]="tiposAmbiente"
            optionLabel="viewValue"
            styleClass="width-100"
            [disabled]="entity.ambiente"
            id="float-input"
          >
          </p-dropdown>
          <label for="float-input">Ambiente *</label>
        </span>
        <small
          class="p-error"
          *ngIf="
            form.get('ambiente').dirty &&
            form.get('ambiente').hasError('required')
          "
        >
          {{ displayMessages.ambiente.required }}
        </small>
      </div>
      <!-- <div class="col-md-4 mt-2">
        <span class="p-float-label">
          <p-dropdown
            [(ngModel)]="form.value.status"
            [formControl]="form.get('status')"
            [options]="tipoStatus"
            optionLabel="viewValue"
            styleClass="width-100"
            id="float-input"
          >
          </p-dropdown>
          <label for="float-input">Status *</label>
        </span>
        <small
          class="p-error"
          *ngIf="
            form.get('status').dirty && form.get('status').hasError('required')
          "
        >
          {{ displayMessages.status.required }}
        </small>
      </div> -->
    </div>
    <div class="col-md-12 mt-2">
      <!-- <span class="p-float-label">
        <input
          id="inputtext-serie"
          (keydown)="notText($event)"
          class="input-filters"
          pInputText
          [formControl]="form.get('serie')"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-serie">Série *</label>
      </span> -->
      <mat-form-field class="w-100" appearance="outline" floatLabel="always">
        <mat-label>Série</mat-label>
        <input
          class="text-right"
          matInput
          id="serie"
          [formControl]="form.get('serie')"
          (keydown)="validateNumbers($event)"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('serie').dirty &&
          form.get('serie').hasError('existSpecialChar')
        "
      >
      {{ displayMessages.serie.existSpecialChar }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('serie').dirty && form.get('serie').hasError('required')
        "
      >
        {{ displayMessages.serie.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('serie').dirty && form.get('serie').hasError('max')
        "
      >
        {{ displayMessages.serie.max }}
      </small>
    </div>
    <!-- <div class="col-md-12 mt-2"> -->
      <!-- <span class="p-float-label">
        <input
          id="inputtext-ultimo_doc"
          class="input-filters"
          pInputText
          (keydown)="notText($event)"
          [formControl]="form.get('ultimo_doc')"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-ultimo_doc">Último documento *</label>
      </span> -->
      <!-- <mat-form-field class="w-100" appearance="outline" floatLabel="always">
        <mat-label>Último documento</mat-label>
        <input
          class="text-right"
          matInput
          id="ultimo_doc"
          [formControl]="form.get('ultimo_doc')"
          (keydown)="validateNumbers($event)"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('ultimo_doc').dirty &&
          form.get('ultimo_doc').hasError('required')
        "
      >
        {{ displayMessages.ultimo_doc.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('ultimo_doc').dirty &&
          form.get('ultimo_doc').hasError('maxlength')
        "
      >
        {{ displayMessages.ultimo_doc.maxlength }}
      </small>
    </div> -->
  </mat-card-content>
  <mat-card-actions>
    <div class="col-md-12 pb-2 flex justify-content-between align-items-center">
      <button
        [disabled]="loading"
        mat-stroked-button
        color="warn"
        (click)="dialogRef.close()"
      >
        Cancelar
      </button>
      <button
        [disabled]="loading || !form.valid"
        mat-raised-button
        color="primary"
        (click)="submit()"
      >
        Cadastrar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
